// extracted by mini-css-extract-plugin
export default {"container":"styles_container__r9JSZ","iconWrapper":"styles_iconWrapper__oaB9l","icon":"styles_icon__7Fie6"};